// import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';

// @Injectable()
// export class PrintProvider {

//   constructor(public http: HttpClient) {
//     console.log('Hello PrintProvider Provider');
//   }

// }


import { Injectable } from '@angular/core';
import domtoimage from 'dom-to-image';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial';
import {AlertController} from 'ionic-angular';

@Injectable()
export class PrintProvider {

  constructor(private btSerial:BluetoothSerial,private alertCtrl:AlertController) {
  }

  print(componentName) {
      var node = document.getElementById(componentName);

      domtoimage.toPng(node)
      .then(function (dataUrl) {
          var popup=window.open();
            popup.document.write('<img src=' + dataUrl + ' width="100%">');
            popup.document.close();
            popup.focus();
            setTimeout(function() {
                popup.print();
                popup.close();
            }, 3000);
      })
      .catch(function (error) {
      });
    }

  searchBt()
  {
    return this.btSerial.list();
  }

  nextline(data){
    // console.log(data)
    if(data != undefined)
      return '\n'
    else
      return ''
  }

  empty(data){
    // console.log(data)
    if(data != undefined)
      return data
    else
      return ''
  }
  connectBT(address)
  {
    return this.btSerial.connect(address);

  }
  fillspace(number, data, type) {
      var qtytotal = number;
      var qtylength = String(data).length
      var qtysum = qtytotal - qtylength;
      if (data) {
        if (qtysum > 0) {
          var qtyspace = data
          for (var j = 0; j < qtysum; j++) {
            if (type == 'backspace') {
              qtyspace = qtyspace + ' ';
            }
            if (type == 'frontspace') {
              qtyspace = ' ' + qtyspace;
            }
          }
        } else {
          var qtyspace = data
        }
        return qtyspace;
      }
      return '';
    }

    centeralign(number, data) {
      if(data != undefined){
      var qtytotal = number;
      var qtylength = String(data).length
      var qtysum = qtytotal - qtylength;
      if (data) {
        if (qtysum > 0) {
          var qtyspace = data
          for (var j = 0; j < qtysum/2; j++) {
              qtyspace = ' '+ qtyspace+' ';
          }   
        } else {
          var qtyspace = data
        }
        return qtyspace;
      }
    }
    else
      return ''
    }


  testPrint(address,componentName)
  {
    console.log('testprint')
    var ProductList = ''
      
    var item=componentName;
   for (var i = 0; i < item.order_item.length; i++) {
        ProductList = ProductList +this.fillspace(18, item.order_item[i].item_name,'backspace').substring(0, 18)+ this.fillspace(3, item.order_item[i].quantity, 'frontspace')+ ""+this.fillspace(5, +item.order_item[i].price, 'frontspace')+ "" +  this.fillspace(6, +item.order_item[i].amount, 'frontspace') +"\n"
      }
          let printData=this.centeralign(32, "Admin App").substring(0, 32)+"\n" +this.centeralign(32, "NO:100, Lake View Estate,").substring(0, 32)+"\n"+this.centeralign(32, "Kundrathur Road,Porur,").substring(0, 32)+"\n"+this.centeralign(32, "Chennai, TN").substring(0, 32)+"\n"+this.centeralign(32, "Phone: 9876543210").substring(0, 32)+"\n"+"\n"+this.fillspace(16,"Invoice:" + item.name, 'backspace') + this.fillspace(16,"Date:"+item.order_date,'frontspace')+ "\n" + "--------------------------------\n" + this.fillspace(16, "Items", 'backspace') + "  Qty " + "Rate " + "Total\n"+ "--------------------------------\n" +ProductList +"--------------------------------\n" +this.fillspace(22, "Sub Total", 'backspace')+this.fillspace(10,Math.round(item.order_subtotal*100)/100 ,  'frontspace')+"\n"+this.fillspace(22, "Tax", 'backspace')+this.fillspace(10,Math.round(item.vat*100)/100,'frontspace')+"\n"+this.fillspace(22, "Discount", 'backspace')+this.fillspace(10, String(item.discount),  'frontspace')+"\n"+"--------------------------------\n" +this.fillspace(22, "Total", 'backspace')+this.fillspace(10,Math.round(item.total_amount*100)/100 ,  'frontspace')+"\n"+ "--------------------------------\n\n"+"\n\n"
    // let printData="admin"

    // let printData="adjhsajkd"
    let xyz=this.connectBT(address).subscribe(data=>{
      this.btSerial.write(printData).then(dataz=>{

        let mno=this.alertCtrl.create({
          title:"Print SUCCESS!",
          buttons:['Dismiss']
        });
        mno.present();

        xyz.unsubscribe();
      },errx=>{
        let mno=this.alertCtrl.create({
          title:"ERROR "+errx,
          buttons:['Dismiss']
        });
        mno.present();
      });
      },err=>{
        let mno=this.alertCtrl.create({
          title:"ERROR "+err,
          buttons:['Dismiss']
        });
        mno.present();
      });

  }  

}




// WEBPACK FOOTER //
// ./src/providers/print/print.ts